import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/razonSocial';

// LOGIN

function iniciarRazonSocial(state, action) {

  state.id= action.payload.id ? action.payload.id:null;
	state.rut= action.payload.rut ? action.payload.rut:null;
	state.razonsocial= action.payload.razonsocial ? action.payload.razonsocial:null;
	state.abog_patroc= action.payload.abog_patroc ? action.payload.abog_patroc:null;
	state.rut_abog_patroc= action.payload.rut_abog_patroc ? action.payload.rut_abog_patroc:null;
	state.abog_deman= action.payload.abog_deman ? action.payload.abog_deman:null;
	state.rut_abog_deman= action.payload.rut_abog_deman ? action.payload.rut_abog_deman:null;
  state.conexion = false;
  state.error = false;


}

function razonSocialSetId(state, action) {
  state.id= action.payload.id ? action.payload.id:null;
  state.conexion = false;
}


function conexionRazonSocial(state, action) {
  state.conexion= action.payload.conexion;
}

function errorRazonSocial(state, action) {
  state.error = action.payload.error;
  state.message = action.payload.message;
}






/**
 * Conexión
 */
const razonSocialReducer = createSlice({
  name: 'razonSocial',
  initialState: initState,
  reducers: {
    iniciarRazonSocial,
    razonSocialSetId,
    conexionRazonSocial,
    errorRazonSocial
  },
});

export const razonSocialActions = {
  ...razonSocialReducer.actions,
};

export default razonSocialReducer.reducer;
